import { render, staticRenderFns } from "./ClientPreferenceResults.vue?vue&type=template&id=5fdc61c5&scoped=true&"
import script from "./ClientPreferenceResults.vue?vue&type=script&lang=js&"
export * from "./ClientPreferenceResults.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fdc61c5",
  null
  
)

export default component.exports